module.exports = __webpack_public_path__ + "yt.svg?f91334afbba9289be742a718421eb757";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/yt.svg
// module id = 979
// module chunks = 27